export default __webpack_public_path__ + "images/7B.44c7f7b.png";